import { isServer } from './env-helper';
import { map } from './map';

export const SessionStorageKey = {
  IpTempHash: 'FLIPSTER_IP_TEMP_HASH',
  AuthErrorMessage: 'FLIPSTER_AUTH_ERROR_MESSAGE',
  SignUpFloatingIconClosed: 'FLIPSTER_SIGN_UP_FLOATING_ICON_CLOSED',
} as const;

export interface SessionStorageValue {
  [SessionStorageKey.IpTempHash]: string;
  [SessionStorageKey.AuthErrorMessage]: string;
  [SessionStorageKey.SignUpFloatingIconClosed]: boolean;
}

export const getSessionStorage = <K extends keyof SessionStorageValue>(
  key: K,
  withDelete: boolean = false,
): SessionStorageValue[K] | null => {
  if (isServer) return null;
  const value = sessionStorage?.getItem(key);
  if (withDelete) sessionStorage?.removeItem(key);
  try {
    return map(value, JSON.parse) as SessionStorageValue[K] | null;
  } catch {
    // fallback - previous value before implement serde or invalid value
    return value as SessionStorageValue[K] | null;
  }
};

export const setSessionStorage = <K extends keyof SessionStorageValue>(key: K, value: SessionStorageValue[K]) => {
  sessionStorage?.setItem(key, JSON.stringify(value));
};

export const deleteSessionStorage = (key: keyof SessionStorageValue) => {
  sessionStorage?.removeItem(key);
};
